import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/arrowdifter1.png'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/arrowdifter3.png'
import srj7 from '../../images/arrowdifter7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/arrowdifter10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';



const Arrowdifter = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>Local Authority & Year-Round <br/> Lead Growth for Arrow Gifter <br/> (Corporate Gifting)</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>35+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>India</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>B2B</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>Corporate Gifting</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>Shadab is the Co-founder of Arrow Gifter, one of <br/> India’s leading corporate gifting companies. The <br/> brand curates premium, customizable gift <br/> solutions for enterprises—covering client <br/> appreciation, HR rewards & recognition, festive <br/> hampers, onboarding kits, conference merch, and <br/> milestone programs—delivered at scale with <br/> branding, kitting, and nationwide logistics.</p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" style={{maxWidth:'60%'}}/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid' style={{maxWidth:'60%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Weak local visibility on Google: Google Business Profile (GBP) existed but wasn’t optimized—low impressions, calls, and direction requests.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Highly competitive location: The city hosts many large companies and established gifting vendors—difficult to break into the Map Pack.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Seasonality risk: Revenue concentrated around festivals (Diwali, New Year), causing lumpy pipeline and under-utilized capacity in off-season months.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>In-house team plateau: Previous SEO/marketing efforts stalled; limited traction for high-intent “corporate gifting” searches.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>At onboarding, Shadab asked us to:</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Build local authority and win the Map Pack for “corporate gifting” terms.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Rank organically on the Google SERP for commercial and near-transaction keywords.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Earn mentions on AI platforms (Google AI Overviews, Bing Copilot, Perplexity) through answer-friendly content and structured data.</li>
                                    </ul>

                                     <h3 className='mt-4'>Client Ask</h3>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>A clear, sustainable SEO plan that doesn’t rely on paid ads.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>The exact local keywords to prioritize for discovery and conversions.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>A step-by-step strategy to scale leads from the home city and expand nationally.</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj7} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>
                    

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'20%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Map Pack competition from long-standing vendors with strong proximity, prominence, and review profiles.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Keyword ambiguity across “corporate gifts”, “festive hampers”, “merch”, and “employee rewards” is cannibalizing intent.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Thin local signals (citations, photos, Posts, Q&A, Products) on GBP and a few city-level landing pages.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Seasonality in content and demand shapes buyer perception that Arrow Gifter is “festive-only.”</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Local SEO Foundation (GBP Rebuild)</div>
                                                <p>We did the complete GMB audit of the Arrow Gifter profile, and then we used our internal tracking tool to optimize the profile on a pincode basis so that we can track the performance of the Google My Business in all the target areas of the city.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Local Authority Signals Beyond GBP</div>
                                                <p>NAP cleanup & citations across high-trust local directories and B2B platforms; consistent name, address, phone, hours.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Website Architecture for Intent Ownership</div>
                                                <p>We have built the clusters & Pillars (commercial) contents like Corporate Gifting, Employee Rewards & Recognition, Onboarding Kits, Festive Hampers, Conference & Event Gifting, Client Welcome Boxes.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI SEO (AEO/GEO) Readiness</div>
                                                <p>Answer-blocks and glossary for AI Overviews: concise definitions (MOQ, kitting, PMS color, lead times), list-style comparisons, and checklists. Fixed and built the Schema for Organization, LocalBusiness, FAQ, Product, Breadcrumb, and ImageObject. Created regular and high authority web mentions.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content to Flatten Seasonality</div>
                                                <p className='mb-0'>We productized evergreen, non-festive demand:</p>
                                                <ul>
                                                    <li>Onboarding kits (monthly hiring cycles)</li>
                                                     <li>Quarterly awards (R&R)</li>
                                                     <li>Client welcome & renewal gifts</li>
                                                     <li>Conference/expo merch (year-round events)</li>
                                                     <li>HR wellness packs and birthday/anniversary programs</li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Local Keyword Plan (Sample Targets)</div>
                                                <p>We localized the list for the primary city and drafted expansion sets for Tier-1 corridors (Delhi NCR, Mumbai, Bengaluru, Hyderabad, Pune), preserving intent and avoiding cannibalization.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>CRO & Lead Quality</div>
                                                <p>We optimized the landing pages and RFQ forms with structured fields (units, branding method, delivery window, budget band). And we did call tracking for GBP and site CTAs; GA4 events mapped to “qualified lead”.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Outreach & PR for Prominence</div>
                                                <p>Local business media features (“Corporate gifting trends,” “HR rewards 2025 playbook”).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Measurement & Governance</div>
                                                <p>We made sure we track everything so that we can avoid the guesswork. For this, we were tracking website UX and user journey, website engagement using heatmaps, Google SERP keyword tracking, and AI Brand mention tracking, etc.</p>
                                            </div>
                                        </li>
                                        

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<>Want to dominate Locally & in AI platforms? </>} title2={<>Let’s build an AI-ready, local-first SEO engine for your city and beyond.</>} />
                    
                    <section className="intro_about_section section_space max_900 project_outcome pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Top 1 Position in Google My Business</div>
                                                <p>Map Pack Lift: Improved visibility and actions from GBP (calls, direction requests, website clicks).</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Organic Google Ranking</div>
                                                <p>Organic ranking gains across commercial local terms (e.g., “corporate gifting company in [City]”, “bulk corporate gifts [City]”).</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Higher Lead Quality</div>
                                                <p>Higher lead quality via RFQ forms and quick-quote workflows.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Continuous Sales & Leads </div>
                                                <p>Seasonality flattened: off-season leads from onboarding kits, R&R, and client welcome boxes.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>High AI Brand Mentions</div>
                                                <p>Mentions in AI answers for targeted queries due to answer-blocks + schema hygiene.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Scalable Content Engine</div>
                                                <p>Repeatable content engine: city page framework ready for national expansion.</p>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default Arrowdifter;
